import { CONTENT_DISPLAY_NAME } from "./core";
import createTestId from "../../../../fabrics/createTestId";

export const createTestIdForContentElement = createTestId(CONTENT_DISPLAY_NAME);
